import { differenceInMilliseconds } from 'date-fns';
import { parseZonedDateTime } from '@internationalized/date';
import { LogisticsLogRecord, LogisticsLogType } from '@lp/features/RoutePlanner/types';
import { CaseLog, CaseLogEventType, ReviewType } from '@/api/apis/case';
import { getTzDateTimeString } from '@/utils/helpers';

const LOGISTICS_EVENTS = [
  CaseLogEventType.RoutePlanningStatusUpdated,
  CaseLogEventType.CaseReviewUpdated,
  CaseLogEventType.CaseQuoteSentToTxCenter,
  CaseLogEventType.CaseQuoteApprovedTxCenterProvider,
];

export const getLogisticsLogs = (logs: CaseLog[]): LogisticsLogType[] => {
  const currentLogs = logs
    .filter((l) => {
      if (l.eventType === CaseLogEventType.CaseReviewUpdated) {
        return !l.logRecords.some((r) => r.value === ReviewType.TXCenterService);
      }

      return LOGISTICS_EVENTS.includes(l.eventType);
    })
    .sort((a, b) => {
      const aCreated = getTzDateTimeString(a.createdAt);
      const bCreated = getTzDateTimeString(b.createdAt);

      return differenceInMilliseconds(
        parseZonedDateTime(aCreated).toAbsoluteString(),
        parseZonedDateTime(bCreated).toAbsoluteString(),
      ) > 0
        ? 1
        : -1;
    });

  return currentLogs.map((item) => {
    const log = {
      eventType: item.eventType,
      user: item.user,
      createdAt: item.createdAt,
      isPositive: true,
      logRecord: {
        type: item.eventType,
        status: item.logRecords[0].value,
        comment: '',
      },
    };

    if (item.eventType === CaseLogEventType.RoutePlanningStatusUpdated) {
      return {
        ...log,
        isPositive: true,
        logRecord: {
          type: 'RoutePlanningStatus',
          status: item.logRecords[0]?.value || '',
          comment: '',
        },
      };
    }

    if (item.eventType === CaseLogEventType.CaseReviewUpdated) {
      return {
        ...log,
        isPositive: item.logRecords.some((r) => r.value === 'Approved'),
        logRecord: item.logRecords.reduce(
          (acc, r) => {
            return {
              ...acc,
              type: r.propertyName === 'ReviewType' ? r.value : acc.type,
              status: r.propertyName === 'ReviewStatus' ? r.value : acc.status,
              comment: r.propertyName === 'Comment' ? r.value : acc.comment,
            };
          },
          {
            type: '',
            status: '',
            comment: '',
          } as LogisticsLogRecord,
        ),
      };
    }

    return log;
  });
};
